// Stylesheets
import './assets/scss/site.scss';
import { hover } from './assets/modules/hover';
import { lazyload } from './assets/modules/lazyload';
import { fluidvideo } from './assets/modules/fluidvideo';
import { initPhotoSwipeFromDOM } from './assets/modules/photoswipe-init';
import { trigger } from './assets/modules/trigger';
import { marqueeClassic } from './assets/modules/marqueeClassic';
import { archiveCarousel } from './assets/modules/archiveCarousel';
import { dateTime } from './assets/modules/dateTime';
import { headerLogo } from './assets/modules/headerLogo';
import { stickyTrigger } from './assets/modules/stickyTrigger';
import { carousel } from './assets/modules/carousel';
import { slideList } from './assets/modules/slideList';
import { copyUrl } from './assets/modules/copyUrl';
import { popup } from './assets/modules/popup';
import { stickySidebar } from './assets/modules/stickySidebar';
import { homeNews } from './assets/modules/homeNews';
import { externalLink } from './assets/modules/externalLink';
import { masonry } from './assets/modules/masonry';
import { andyouArchive } from './assets/modules/andyouView';
import { dictionaryArchive } from './assets/modules/dictionary';

const init = () => {
  hover();
  lazyload();
  fluidvideo();
  headerLogo();
  initPhotoSwipeFromDOM('.js-pswp-container');
  trigger();
  marqueeClassic();
  stickyTrigger();
  archiveCarousel();
  dateTime();
  carousel();
  slideList();
  copyUrl();
  popup();
  stickySidebar();
  homeNews();
  externalLink();
  masonry();
  andyouArchive();
  dictionaryArchive();
}

init();